import { render } from "./VideoPanel.vue?vue&type=template&id=594a9dcc&scoped=true&ts=true"
import script from "./VideoPanel.vue?vue&type=script&lang=ts"
export * from "./VideoPanel.vue?vue&type=script&lang=ts"

import "./VideoPanel.vue?vue&type=style&index=0&id=594a9dcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594a9dcc"]])

export default __exports__